(() => {
  'use strict'

  const previous = window.__pwSearchLauncherRuntime
  if (previous && typeof previous.destroy === 'function') previous.destroy()

  const controller = new AbortController()
  const { signal } = controller
  const guardStyleId = 'pw-search-mobile-dismiss-guard'

  const getModal = () => document.querySelector('header-search.pw-search-modal-root')

  const ensureGuardStyle = () => {
    let style = document.getElementById(guardStyleId)
    if (!style) {
      style = document.createElement('style')
      style.id = guardStyleId
      document.head.appendChild(style)
    }

    style.textContent = `
      .pw-search-modal-root.site-header__search-container {
        z-index: 2147483647 !important;
      }

      html.pw-search-modal-open .pw-wise-club-callout {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      @media (max-width: 768px) {
        .pw-search-modal-root.site-header__search-container.is-active {
          pointer-events: auto !important;
          overscroll-behavior: contain !important;
        }

        .pw-search-modal-root.site-header__search-container.is-active .pw-search-modal__backdrop {
          pointer-events: auto !important;
        }
      }
    `
  }

  const isHeaderLauncherInput = (target, modal) => {
    if (!(target instanceof HTMLInputElement) || target.type !== 'search') return false
    if (modal && modal.contains(target)) return false
    return Boolean(target.closest('#SiteHeader predictive-search[data-context="header"]'))
  }

  const getExplicitTrigger = (target, modal) => {
    if (!(target instanceof Element)) return null
    const trigger = target.closest('#SiteHeader [data-pw-search-modal-trigger]')
    if (!trigger || (modal && modal.contains(trigger))) return null
    return trigger
  }

  const focusModalInput = (modal) => {
    requestAnimationFrame(() => {
      const input = modal.querySelector('predictive-search[data-context="header"] input[type="search"]')
      input?.focus({ preventScroll: true })
    })
  }

  const openModal = (trigger) => {
    const modal = getModal()
    if (!modal) return

    modal.__pwReturnFocus = trigger instanceof HTMLElement && !(trigger instanceof HTMLInputElement)
      ? trigger
      : null

    const open = () => {
      if (typeof modal.openInlineSearch !== 'function') return
      modal.openInlineSearch()
      focusModalInput(modal)
    }

    if (customElements.get('header-search')) open()
    else customElements.whenDefined('header-search').then(open).catch(() => {})

    if (!customElements.get('predictive-search')) {
      customElements.whenDefined('predictive-search').then(() => {
        if (!modal.classList.contains('is-active')) return
        modal.openInlineSearch?.()
        focusModalInput(modal)
      }).catch(() => {})
    }
  }

  ensureGuardStyle()

  document.addEventListener('click', (event) => {
    const modal = getModal()
    const explicitTrigger = getExplicitTrigger(event.target, modal)
    const inputTrigger = isHeaderLauncherInput(event.target, modal) ? event.target : null
    const trigger = explicitTrigger || inputTrigger
    if (!trigger) return

    event.preventDefault()
    event.stopPropagation()
    openModal(trigger)
  }, { capture: true, signal })

  document.addEventListener('focusin', (event) => {
    const modal = getModal()
    if (!isHeaderLauncherInput(event.target, modal)) return
    if (modal?.classList.contains('is-active')) return
    openModal(event.target)
  }, { signal })

  window.__pwSearchLauncherRuntime = {
    destroy() {
      controller.abort()
      document.getElementById(guardStyleId)?.remove()
    }
  }
})()
